import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { getCompleteData, getItems, getYears } from '../../../actions/HomeAction';

function EngineeringAdvancedSearch({ filters, setFilters, categories, subcategories: passedSubcategories }) {
  const [subcategories, setSubcategories] = useState([]);
  const [regions, setRegions] = useState([]);
  const [years, setYears] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);

  const initialAdvancedFilters = {
    year: '',
    regionId: '',
    material: '',
    compatibleModels: '',
    features: '',
    certifications: '',
    productType: '',
    subcategoryId: ''
  };

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderRadius: "6px",
      borderColor: "#ced4da",
      marginBottom: "10px",
      fontSize: "14px",
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };

  useEffect(() => {
    getItems(setRegions);
    setYears(getYears());
    getCompleteData(setBrands, null, setModels);
  }, []);

  useEffect(() => {
    if (!filters.categoryId) {
      setSubcategories([]);
      return;
    }
    if (passedSubcategories && passedSubcategories.length > 0) {
      setSubcategories(passedSubcategories);
      return;
    }
    const selectedCat = categories?.find(
      (cat) => cat._id === filters.categoryId
    );
    setSubcategories(selectedCat?.subcategories || []);
  }, [filters.categoryId, passedSubcategories, categories]);

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setFilters({ ...filters, [name]: value });
  };

  const clearFilters = () => {
    setFilters(initialAdvancedFilters);
  };

  const subcategoryOptions = subcategories.map((sub) => ({
    value: sub._id,
    label: sub.name,
  }));

  const yearOptions = years.map((y) => ({
    value: String(y),
    label: String(y),
  }));

  const regionOptions = regions.map((r) => ({
    value: r._id,
    label: r.name,
  }));

  const materialOptions = [
    { value: "Steel", label: "Steel" },
    { value: "Aluminum", label: "Aluminum" },
    { value: "Iron", label: "Iron" },
    { value: "Plastic", label: "Plastic" },
    { value: "Rubber", label: "Rubber" },
    { value: "Fiber", label: "Fiber" },
    { value: "Copper", label: "Copper" },
    { value: "Brass", label: "Brass" },
    { value: "Carbon Fiber", label: "Carbon Fiber" },
    { value: "Titanium", label: "Titanium" },
    { value: "Alloy", label: "Alloy" },
  ];

  const compatibleModelOptions = [
    { value: "Heavy Duty", label: "Heavy Duty" },
    { value: "Standard", label: "Standard" },
    { value: "Series A", label: "Series A" },
    { value: "Series B", label: "Series B" },
    { value: "Universal", label: "Universal" },
    { value: "Model 100", label: "Model 100" },
    { value: "Model 200", label: "Model 200" },
  ];

  const featureOptions = [
    { value: "Waterproof", label: "Waterproof" },
    { value: "Heat Resistant", label: "Heat Resistant" },
    { value: "High Durability", label: "High Durability" },
    { value: "Corrosion Resistant", label: "Corrosion Resistant" },
    { value: "High Speed", label: "High Speed" },
    { value: "Insulated", label: "Insulated" },
  ];

  const certificationOptions = [
    { value: "ISO 9001", label: "ISO 9001" },
    { value: "CE Certified", label: "CE Certified" },
    { value: "RoHS Compliant", label: "RoHS Compliant" },
    { value: "SAE Certified", label: "SAE Certified" },
    { value: "DOT Approved", label: "DOT Approved" },
  ];

  const productTypeOptions = [
    { value: "Engineering", label: "Engineering" },
    { value: "Auto-Spare", label: "Auto-Spare" },
    { value: "Building", label: "Building" },
    { value: "Rental", label: "Rental" },
    { value: "Industrial", label: "Industrial" },
    { value: "Marine", label: "Marine" },
  ];

  return (
    <div className="container py-4">
      <h4 className="mb-3">Engineering Advanced Search</h4>

      <button
        type="button"
        className="btn btn-sm btn-outline-danger w-100 mb-3 fw-bold"
        onClick={clearFilters}
      >
        Clear Filters
      </button>

      {subcategories.length > 0 && (
        <div className="mb-2">
          <Select
            isClearable
            isSearchable
            placeholder="Subcategory..."
            options={subcategoryOptions}
            value={subcategoryOptions.find((o) => o.value === filters.subcategoryId) || null}
            onChange={(opt) => handleSelectChange("subcategoryId", opt)}
            styles={customSelectStyles}
          />
        </div>
      )}

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Year..."
          options={yearOptions}
          value={yearOptions.find((o) => o.value === String(filters.year)) || null}
          onChange={(opt) => handleSelectChange("year", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Region..."
          options={regionOptions}
          value={regionOptions.find((o) => o.value === filters.regionId) || null}
          onChange={(opt) => handleSelectChange("regionId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Material..."
          options={materialOptions}
          value={materialOptions.find((o) => o.value === filters.material) || null}
          onChange={(opt) => handleSelectChange("material", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Compatible Models..."
          options={compatibleModelOptions}
          value={compatibleModelOptions.find((o) => o.value === filters.compatibleModels) || null}
          onChange={(opt) => handleSelectChange("compatibleModels", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Features..."
          options={featureOptions}
          value={featureOptions.find((o) => o.value === filters.features) || null}
          onChange={(opt) => handleSelectChange("features", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Certifications..."
          options={certificationOptions}
          value={certificationOptions.find((o) => o.value === filters.certifications) || null}
          onChange={(opt) => handleSelectChange("certifications", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Product Type..."
          options={productTypeOptions}
          value={productTypeOptions.find((o) => o.value === filters.productType) || null}
          onChange={(opt) => handleSelectChange("productType", opt)}
          styles={customSelectStyles}
        />
      </div>
    </div>
  );
}

export default EngineeringAdvancedSearch;
